import { Form, Modal } from "antd";
import React from "react";
import { CreateDropResultDto } from "../../../api";
import { DropResultColumns } from "../form/columns";

interface DropResultFormProps {
  visible: boolean;
  setVisible: Function;
  onCreateDropResult: (values: CreateDropResultDto) => void;
}

export const DropResultForm: React.FC<DropResultFormProps> = ({ visible, setVisible, onCreateDropResult }) => {
  const [form] = Form.useForm<CreateDropResultDto>();

  return (
    <Modal open={visible} onOk={form.submit} okText="Создать" cancelText="Отмена" onCancel={() => setVisible(false)}>
      <Form form={form} className="p-8" layout="vertical" onFinish={onCreateDropResult}>
        {DropResultColumns().map(({ title, key, rules, inputNode, hideOnForm }, index) => (
          <>
            {!hideOnForm && <Form.Item label={title} name={key} rules={rules} key={index}>
              {inputNode}
            </Form.Item>}
          </>
        ))}
      </Form>
    </Modal>
  );
};
